var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 345,
    height: 279,
    viewBox: "0 0 345 279",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.529489,
    y: 0.529489,
    width: 343.109,
    height: 277.452,
    rx: 16.4142,
    stroke: "url(#paint0_linear_15615_4524)",
    strokeWidth: 1.05898
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15615_4524)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 344.168,
    height: 276.393,
    rx: 16.9437,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.877 230.759C173.877 233.599 171.744 236.002 168.909 236.181C164.596 236.453 160.268 236.453 155.955 236.181C153.121 236.002 150.987 233.599 150.987 230.759V219.07C150.987 215.99 153.483 213.493 156.563 213.493H168.301C171.381 213.493 173.877 215.99 173.877 219.07V230.759ZM162.209 133.14C163.845 133.14 165.464 133.475 166.964 134.125C169.644 135.316 171.755 137.4 173.812 139.484L232.099 197.777C234.324 200.002 234.268 203.627 231.975 205.783L223.371 213.871C221.175 215.935 217.736 215.881 215.606 213.749L174.399 172.492C172.175 170.268 169.876 167.99 166.973 166.772C164.192 165.62 161.083 165.532 158.241 166.525C154.846 167.716 152.178 170.349 149.632 172.895L106.63 215.877C105.694 216.813 104.185 216.836 103.22 215.93V215.93L101.491 214.301L99.7603 212.676L98.0308 211.05L96.2983 209.421L94.5679 207.796L92.8384 206.17L91.1079 204.541L89.3784 202.915L88.8013 202.371L88.5034 202.103C88.4743 202.079 88.4457 202.056 88.4175 202.032C88.2902 201.922 88.2817 201.728 88.4106 201.62V201.62L88.6196 201.409L89.0386 200.989L89.8784 200.149L91.5581 198.471L93.2368 196.791L94.9165 195.108L98.2749 191.75L99.9575 190.071L101.636 188.392L103.328 186.739L105.007 185.057L106.686 183.378L108.389 181.678L111.748 178.319L113.427 176.637L118.465 171.599L120.147 169.92L121.827 168.237L125.185 164.879L126.849 163.218L130.208 159.859L131.887 158.177L133.566 156.497L135.246 154.818L143.645 146.419L145.324 144.739L147.003 143.061L148.683 141.378L150.371 139.696L150.606 139.461C152.663 137.404 154.775 135.292 157.455 134.125C158.955 133.475 160.574 133.14 162.209 133.14ZM110.638 76.0508L150.966 116.389C152.798 118.221 152.798 121.19 150.967 123.022V123.022L141.362 132.624L138.051 135.938L120.034 153.956C118.988 155.002 117.57 155.59 116.091 155.59H71.9773C69.2441 155.59 66.896 153.61 66.5882 150.894C66.1756 147.254 65.9694 143.591 65.9712 139.925C65.9712 139.216 65.9787 138.509 65.9937 137.804C66.056 134.886 68.4973 132.637 71.4151 132.637H121.278C126.246 132.637 128.734 126.631 125.222 123.118L88.1736 86.058C86.2253 84.109 85.979 81.0171 87.7223 78.8828C88.5059 77.9234 89.3083 76.9794 90.1294 76.0508C92.2061 73.6983 94.3955 71.4486 96.6893 69.3098C98.8034 67.3386 102.083 67.4946 104.127 69.5386L110.638 76.0508ZM220.76 69.551C222.804 67.5073 226.084 67.3524 228.198 69.3242C230.491 71.4627 232.68 73.7114 234.757 76.0625C235.575 76.9887 236.375 77.9303 237.158 78.8872C238.91 81.0262 238.669 84.1294 236.714 86.0842L199.684 123.114C196.171 126.627 198.659 132.634 203.627 132.634H253.469C256.388 132.634 258.829 134.885 258.893 137.804C258.908 138.504 258.916 139.206 258.917 139.911C258.918 143.577 258.712 147.239 258.299 150.88C257.992 153.596 255.644 155.575 252.91 155.575H208.883C207.404 155.575 205.985 154.988 204.939 153.942L173.919 122.922V122.922C172.111 121.113 172.111 118.18 173.919 116.371V116.371L220.76 69.551ZM150.958 49.0811C150.958 46.2546 153.073 43.8574 155.893 43.6682C160.249 43.3761 164.621 43.3761 168.977 43.6682C171.797 43.8574 173.912 46.2546 173.912 49.0811V70.4783C173.912 73.5581 171.415 76.0547 168.335 76.0547H156.535C153.455 76.0547 150.958 73.5581 150.958 70.4783V49.0811Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.87 213.494V235.747C166.266 236.597 158.583 236.597 150.979 235.747V213.494H173.87Z",
    fill: "#8A8989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.161 201.848L219.425 217.581L174.395 172.496C172.17 170.272 169.872 167.995 166.969 166.777C164.187 165.624 161.078 165.536 158.236 166.53C154.842 167.721 152.174 170.353 149.628 172.898L104.946 217.56L103.216 215.934L101.486 214.305L99.7566 212.68L98.0267 211.054L96.2938 209.425L94.564 207.8L92.8341 206.174L91.1042 204.545L89.3743 202.92L88.7967 202.375L88.4989 202.107C88.3932 202.023 88.2937 201.931 88.2012 201.833C88.2627 201.757 88.3315 201.687 88.4066 201.625L88.6151 201.413L89.0349 200.993L89.8745 200.154L91.5538 198.474L93.2331 196.795L94.9123 195.113L96.5915 193.434L98.2708 191.754L99.953 190.075L101.632 188.396L103.324 186.743L105.003 185.061L106.682 183.382L108.385 181.682L110.064 180.003L111.744 178.323L113.423 176.641L115.102 174.962L116.781 173.282L118.461 171.603L120.143 169.924L121.822 168.242L123.502 166.562L125.181 164.883L126.845 163.222L128.524 161.543L130.204 159.863L131.883 158.181L133.562 156.502L135.241 154.822L136.921 153.143L138.6 151.464L140.282 149.782L141.962 148.102L143.641 146.423L145.32 144.744L146.999 143.065L148.679 141.382L150.367 139.7L150.602 139.465C152.659 137.408 154.77 135.297 157.45 134.129C158.951 133.479 160.569 133.144 162.205 133.144C163.841 133.144 165.459 133.479 166.96 134.129C169.64 135.32 171.751 137.405 173.808 139.489L236.161 201.848Z",
    fill: "#8A8989"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.1367,
    y1: 133.046,
    x2: 317.032,
    y2: 133.046,
    stroke: "#8A8989",
    strokeWidth: 0.241178
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.9954,
    y1: 36.3688,
    x2: 275.983,
    y2: 241.356,
    stroke: "#8A8989",
    strokeWidth: 0.241178
  }), /*#__PURE__*/React.createElement("line", {
    x1: 173.408,
    y1: -0.926758,
    x2: 173.408,
    y2: 288.969,
    stroke: "#8A8989",
    strokeWidth: 0.241178
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.082,
    y1: 49.6771,
    x2: 68.0953,
    y2: 254.664,
    stroke: "#8A8989",
    strokeWidth: 0.241178
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.1367,
    y1: 155.717,
    x2: 317.032,
    y2: 155.717,
    stroke: "#8A8989",
    strokeWidth: 0.241178
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.9534,
    y1: 52.4001,
    x2: 259.941,
    y2: 257.387,
    stroke: "#8A8989",
    strokeWidth: 0.241178
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150.74,
    y1: -0.926758,
    x2: 150.74,
    y2: 288.969,
    stroke: "#8A8989",
    strokeWidth: 0.241178
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.049,
    y1: 33.6478,
    x2: 52.0621,
    y2: 238.635,
    stroke: "#8A8989",
    strokeWidth: 0.241178
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.194,
    cy: 139.557,
    rx: 96.471,
    ry: 96.3505,
    stroke: "#8A8989",
    strokeWidth: 0.482355,
    strokeDasharray: "7.72 7.72"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15615_4524",
    x1: 172.084,
    y1: 0,
    x2: 172.084,
    y2: 278.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15615_4524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 344.168,
    height: 276.393,
    rx: 16.9437,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.93a541e8fdfd67299963d72dfaa7b134.svg";
export { ForwardRef as ReactComponent };